/**
 * Utility to get app version from package.json
 * This allows us to have a single source of truth for versioning
 */

import packageJson from '../../package.json';

/**
 * Get the app version from package.json
 * @returns {string} Version string (e.g., "0.1.0" or "2.1.0")
 */
export const getAppVersion = () => {
  return packageJson.version || '0.1.0';
};

/**
 * Get formatted version string for display (e.g., "V 2.1.0")
 * @returns {string} Formatted version string
 */
export const getFormattedVersion = () => {
  const version = getAppVersion();
  return `V ${version}`;
};

export default getAppVersion;

